import { useEffect } from 'react'
import { useDoc } from '@/hooks/useDoc'
import { DocMarkdown } from './DocMarkdown'
import { X, Loader2, AlertCircle } from 'lucide-react'

type Props = {
  section: string
  open: boolean
  onClose: () => void
}

export function DocDrawer({ section, open, onClose }: Props) {
  const { content, loading, error } = useDoc(open ? section : null)

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    if (open) document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-40" onClick={onClose} />
      <div className="fixed top-0 right-0 z-50 h-full w-full md:w-[480px] bg-card border-l border-border shadow-2xl overflow-y-auto">
        <div className="sticky top-0 z-10 flex items-center justify-between p-4 border-b border-border bg-card">
          <span className="text-sm font-medium text-text">Документация</span>
          <button onClick={onClose} className="p-1 rounded hover:bg-accent-soft/30 text-text-muted hover:text-text transition-colors">
            <X size={18} />
          </button>
        </div>
        <div className="p-4">
          {loading && (
            <div className="flex items-center gap-2 text-text-muted text-sm py-8 justify-center">
              <Loader2 size={16} className="animate-spin" />
              Загрузка...
            </div>
          )}
          {error && (
            <div className="flex items-center gap-2 text-red text-sm py-8 justify-center">
              <AlertCircle size={16} />
              Ошибка загрузки: {error}
            </div>
          )}
          {content && <DocMarkdown content={content} />}
        </div>
      </div>
    </>
  )
}
